<template>
  <v-app id="vanhoutte-cp">
    <app-user-drawer
      v-if="userLoggedIn"
      :drawer="userDrawer"
      :user-name="userFullName"
      @user-logout="userLogout" />
    <app-primary-toolbar
      v-if="userLoggedIn"
      @toggle-navigation-drawer="navigationDrawer = !navigationDrawer"
      @toggle-user-drawer="userDrawer = !userDrawer" />
    <router-view />
  </v-app>
</template>

<script>
import appPrimaryToolbar from "@/components/ThePrimaryToolbar";
import appUserDrawer from "@/components/TheUserDrawer";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "App",
  components: {
    appPrimaryToolbar,
    appUserDrawer
  },
  data() {
    return {
      userDrawer: false
    };
  },
  computed: {
    ...mapGetters({
      userLoggedIn: "user/getLoggedIn",
      userFullName: "user/getFullName"
    })
  },
  created() {
    if (localStorage.getItem("token")) {
      this.userAutoLogin()
        .then(() => {
          this.$router.push("/category");
        });
    }
  },
  methods: {
    ...mapActions({
      userAutoLogin: "user/autoLogin",
      userLogout: "user/logout"
    })
  }
};
</script>

<style lang="scss">
.card--flex-toolbar {
    margin-top: -64px;
  }

.sub-header {
  text-transform: uppercase;
}
</style>
